import { publicPage, languagePath } from "@/lib/seo";
import React from "react";
import { Home, Languages } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { t, setLanguage, useLanguage } from "@/lib/i18n";

export default function LanguageSwitcher({ children }) {
  const language = useLanguage();
  const page = publicPage(useLocation().pathname);
  return <div className="language-bar" data-testid="language-switcher">
    <div className="flex items-center gap-1">
    <Link to={languagePath("/", language)} className="site-home-link" aria-label={t("VanshVriksham home")} title={t("VanshVriksham home")}>
      <span className="banyan-icon" aria-hidden="true" />
      <span>{t("VanshVriksham")}</span>
    </Link>
    <Link to={languagePath("/", language)} className="site-home-icon" aria-label={t("VanshVriksham home")} title={t("VanshVriksham home")} data-testid="header-home-button"><Home size={20} aria-hidden="true" /></Link>
    </div>
    <div className="flex items-center gap-2">
    {children}
    <div className="language-options flex items-center gap-2" role="group" aria-label="Language / भाषा">
      <Languages size={17} aria-hidden="true" />
      {page ? <Link lang="en" aria-current={page.language === "en" ? "page" : undefined} to={languagePath(page.base, "en")} data-testid="language-english">English</Link> : <button type="button" lang="en" aria-pressed={language === "en"} onClick={() => setLanguage("en")} data-testid="language-english">English</button>}
      {page ? <Link lang="hi" aria-current={page.language === "hi" ? "page" : undefined} to={languagePath(page.base, "hi")} data-testid="language-hindi">हिन्दी</Link> : <button type="button" lang="hi" aria-pressed={language === "hi"} onClick={() => setLanguage("hi")} data-testid="language-hindi">हिन्दी</button>}
    </div>
    </div>
  </div>;
}
